import React from 'react';
import './VoipComplianceTab.css';

const VoipComplianceTab = () => {
  return (
    <div className="voip-compliance-tab">
      <div className="voip-placeholder-container">
        <div className="voip-placeholder-content">
        
          <h2 style={{fontSize:'18px'}}>VoIP Compliance - Coming Soon</h2>
          <p className="voip-description">
            VoIP-specific compliance features will be available in a future update.
          </p>

          <div className="voip-features-preview">
            <h3>Features in development:</h3>
            <ul>
              <li>
                <span className="feature-icon">✓</span>
                <span>VoIP caller verification and identity trust products</span>
              </li>
              <li>
                <span className="feature-icon">✓</span>
                <span>Emergency services (E911) compliance configuration</span>
              </li>
              <li>
                <span className="feature-icon">✓</span>
                <span>International VoIP regulations and carrier requirements</span>
              </li>
              <li>
                <span className="feature-icon">✓</span>
                <span>VoIP quality monitoring and compliance reporting</span>
              </li>
            </ul>
          </div>

        

          <div className="voip-contact-info">
            <p>
              Need VoIP compliance now? <a href="mailto:support@zyratalk.com">Contact our support team</a> for assistance.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoipComplianceTab;
